<template>
  <div>
    <div style="height: 70px;"></div>
    <div class="step-layer">
      <div class="step">
        <div class="step-item current">
          <div class="step-icon">1</div>
          <div class="step-title" v-text="$t('adv_common.first') + $t('adv_common.end')"></div>
        </div>
        <div class="step-line"></div>
        <div class="step-item current">
          <div class="step-icon">2</div>
          <div class="step-title" v-text="$t('adv_common.second') + $t('adv_common.end')"></div>
        </div>
        <div class="step-line"></div>
        <div class="step-item current">
          <div class="step-icon">3</div>
          <div class="step-title" v-text="$t('adv_common.third')"></div>
        </div>
      </div>
    </div>

    <div class="btn">
      <div v-text="$t('create_adv.title')"></div>
      <div class="group-desc" v-text="$t('create_adv.desc')"></div>
    </div>

    <div class="layer">
      <div class="one-line">
        <span class="title" v-text="$t('create_adv.group_name')"></span>{{ group_name }}
        <span class="title" style="margin-left: 30px;" v-show="content !== ''" v-text="$t('create_adv.keyword')"></span>{{ content }}
      </div>
      <div class="adv-desc" v-text="$t('create_adv.keyword_desc')"></div>
    </div>

    <div class="layer-2">
      <div class="left-content">
        <div class="left-header" v-text="$t('create_adv.title2')"></div>
        <el-input v-model="form.url" :placeholder="$t('create_adv.url')" size="small"></el-input>
        <div class="left-title" v-text="$t('create_adv.name')"></div>
        <el-input type="text" :placeholder="$t('create_adv.name_p')" v-model="form.title" maxlength="30" size="small" show-word-limit style="margin-top: 5px;"></el-input>
        <div class="left-title" style="display: flex; align-items: center;">上传图片
          <el-upload action="" ref="upload" class="avatar-uploader" :show-file-list="false" :on-change="logoUpload">
            <img v-if="form.video_path" :src="getImage(form.video_path)" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
      </div>
      <div class="right-content">
        <div class="top-content">
          <div class="top-header" v-text="$t('create_adv.right_title')"></div>
          <div class="content">
            <div class="left-svg">
              <el-progress type="circle" :percentage="65" :width="80" :show-text="false"></el-progress>
              <div class="font" v-text="$t('create_adv.state')"></div>
            </div>
            <div class="right-line">
              <div class="right-header" v-text="$t('create_adv.right_keyword')"></div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword1') }}</div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword2') }}</div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword3') }}</div>
              <div class="line"><i class="el-icon-star-on"></i>{{ $t('create_adv.keyword4') }}</div>
            </div>
          </div>
        </div>
        <div class="bottom-view">
          <div class="title" v-text="$t('create_adv.look')"></div>
          <div class="padding-content" v-text="$t('create_adv.look_content')"></div>
        </div>
      </div>
    </div>

    <div class="btn">
      <el-button type="primary" size="small" @click="save" v-text="$t('adv_common.save_btn2')"></el-button>
      <el-button type="text" @click="cancel" v-text="$t('common.layer_btn_cancel')"></el-button>
    </div>
    <div style="height: 100px;"></div>
  </div>

</template>

<script>
export default {
  name: 'createAdv',
  props: ['adv_data', 'group_id'],
  data() {
    return {
      form: {
        adv_id: '',
        plan_id: '',
        group_id: '',
        url: '',
        title: '',
        video_path: ''
      },
      videoFlag: false,
      videoUploadPercent: '',
      isShowUploadVideo: false,
      group_name: '',
      content: '',
      type: 'add',
      group_lists: []
    };
  },
  created() {
    this.form.group_id = this.group_id;
    let title = this.$t('create_adv.create');
    if (this.adv_data.adv_id !== undefined && parseInt(this.adv_data.adv_id) > 0) {
      this.form = {
        adv_id: this.adv_data.adv_id,
        plan_id: this.adv_data.plan_id,
        group_id: this.adv_data.group_id,
        url: this.adv_data.url,
        title: this.adv_data.title,
        video_path: this.adv_data.video_path
      };
      this.type = 'edit';
      title = this.$t('create_adv.edit');
    }

    this.$http.post('/trader/index/getGroupInfo', {
      group_id: this.group_id
    }).then(res => {
      if (res.code === 200) {
        this.form.plan_id = res.data.plan_id;
        this.form.group_id = res.data.group_id;
        this.group_name = res.data.group_name;
        this.content = res.data.content.join(',');
        this.form.url = this.form.url === '' ? res.data.url : this.form.url;
        this.$function.hiddenLoading();
      }
    });
    document.title = `${title}` + this.$t('create_adv.adv');
  },
  methods: {
    getShowLink() {
      return this.$Config.apiUrl + this.form.video_path;
    },
    save() {
      if (this.form.url === '') {
        this.$message.error(this.$t('create_adv.url_verify'));
        return false;
      }
      if (this.form.title === '') {
        this.$message.error(this.$t('create_adv.title_verify'));
        return false;
      }
      if (this.form.video_path === '') {
        this.$message.error(this.$t('create_adv.video_verify'));
        return false;
      }
      const url = this.type === 'add' ? '/trader/index/createAdv' : '/trader/index/saveAdv';
      this.$http.post(url, this.form).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('create_adv.success'));
          this.cancel();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    cancel() {
      this.$emit('jump_adv', 'AdvView');
    },
    getLink() {
      return this.$Config.apiUrl + '/index/index/fileUpload';
    },

    logoUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return;
      }
      if (file.raw.type.includes('gif')) {
        this.$message.error('图片格式不能是GIF');
        return;
      }

      this.$function.blobToDataURL(file.raw, res => {
        const imgType = file.raw.type.split('/');
        this.form.suffix = imgType[1];
        this.form.video_path = res;
      });
    },
    getImage(logo) {
      return logo.includes('base64,') ? logo : this.$Config.apiUrl + logo;
    }
  }
};
</script>

<style lang="less" scoped="">
  .btn {
    width: 1088px;
    margin: 40px auto;
    font-size: 15px;
    color: #222;
    .group-desc {
      margin-top: 20px;
      color: rgba(32,33,36,.86);
      font-size: 13px;
    }
  }
  .layer {
    width: 1024px;
    padding: 24px 32px;
    margin: 20px auto;
    background: #fff;
    font-size: 14px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
    color: rgba(32,33,36,.86);
    .adv-desc {
      font-size: 13px;
      margin-top: 20px;
      padding-top: 10px;
      border-top: 1px solid rgba(32,33,36,.86);
    }

    .one-line {
      .title {
        color: #757575;
      }
    }
  }

  .layer-2 {
    width: 1088px;
    margin: 20px auto;
    background: #fff;
    font-size: 14px;
    box-shadow: 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12), 0 3px 5px -1px rgba(0,0,0,.2);
    display: flex;

    .left-content {
      width: 488px;
      padding: 16px;
      background: #fff;
      color: rgba(32,33,36,.86);
      .left-header {
        font-size: 12px;
        margin-bottom: 10px;
      }
      .left-title {
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .right-content {
      width: calc(100% - 520px);
      color: rgba(32,33,36,.86);
      .top-content {
        padding: 16px;
        box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
        .top-header {
          font-size: 14px;
        }
        .content {
          display: flex;
          .left-svg {
            width: 140px;
            text-align: center;
            padding: 30px;

            .font {
              width: 100%;
              font-size: 14px;
              text-align: center;
              margin-top: 10px;
            }
          }
          .right-line {
            width: calc(100% - 140px);
            font-size: 13px;
            .right-header {
              border-bottom: 2px solid rgba(0,0,0,.26);;
              padding-bottom: 10px;
              margin-bottom: 10px;
            }
            .line {
              height: 30px;
              line-height: 30px;
            }
          }
        }
      }
      .bottom-view {
        height: 160px;
        padding: 16px;
        background: #F1F3F4;
        .padding-content {
          padding: 30px;
          color: #5f6368;
          font-size: 12px;
        }
      }
    }
  }

  .step-layer {
    width: 100%;
    background: #fff;
    height: 70px;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
    display: flex;
    align-items: center;
    position: fixed;
    top: 66px;
    background: #fff;
    z-index: 2;
    .step {
      margin-left: 30px;
      display: flex;
      align-items: center;
      .step-item {
        display: flex;
        align-items: center;
        font-size: 14px;
        .step-icon {
          width: 28px;
          height: 28px;
          text-align: center;
          line-height: 28px;
          color: #fff;
          background: #616161;
          border-radius: 50%;
          font-size: 12px;
          margin-right: 8px;
        }
      }
      .step-line {
        width: 50px;
        height: 1px;
        background: #BDBDBD;
        margin: 0 8px;
      }
      .current {
        .step-icon {
          background: #4285F4;
        }
      }
    }
  }

  .avatar-uploader {
    margin-left: 20px;
    width: 135px;
    display: inline-block;
    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409EFF;
    }
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    min-width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  .avatar {
    min-width: 128px;
    height: 128px;
    display: block;
  }
</style>
